import { TESTIDS } from "@/constants/testIds";
import { IMAGES } from "@/data/content";
import { Reveal } from "./Reveal";

const stats = [
  { v: "10", l: "lat doświadczenia" },
  { v: "Autyzm", l: "specjalizacja" },
  { v: "3 role", l: "nauczyciel • logopeda • terapeuta" },
];

export const About = () => (
  <section id="o-mnie" data-testid={TESTIDS.about.section} className="py-24 lg:py-32 px-5 sm:px-8">
    <div className="mx-auto max-w-6xl grid lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <div className="relative">
          <div className="absolute -inset-4 rounded-[2.5rem] bg-gradient-to-br from-violet-soft/50 to-blush/60 blur-2xl" />
          <div className="relative rounded-[2rem] overflow-hidden bg-gradient-to-b from-[#F5F3FF] to-[#FDF2F8] shadow-[0_30px_80px_-20px_rgb(90,60,140,0.3)]">
            <img
              src={IMAGES.creator}
              alt="Justyna Skowrońska, nauczyciel specjalny i logopeda"
              className="w-full aspect-[4/5] object-cover object-top"
            />
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="text-sm tracking-widest uppercase text-violet-deep font-600">O mnie</p>
          <h2 className="mt-4 font-display font-700 text-4xl sm:text-5xl tracking-tighter text-ink leading-[1.05]">
            Cześć, jestem Justyna.
          </h2>
          <div className="mt-6 space-y-4 text-lg text-ink/60 leading-relaxed">
            <p>
              Nazywam się <span className="text-ink font-600">Justyna Skowrońska</span> i od prawie
              10 lat wspieram dzieci neuroróżnorodne oraz ich rodziny. Jestem nauczycielem specjalnym
              i logopedą, a specjalizuję się w terapii autyzmu.
            </p>
            <p>
              Na co dzień pomagam dzieciom rozwijać komunikację, samodzielność, umiejętności społeczne
              i pewność siebie, a rodzicom daję praktyczne narzędzia, dzięki którym mogą lepiej zrozumieć
              potrzeby swoich dzieci. Łączę wiedzę naukową z wieloletnim doświadczeniem zdobytym w szkołach,
              placówkach specjalistycznych i podczas indywidualnej pracy z rodzinami.
            </p>
            <p>
              Wierzę, że każde dziecko zasługuje na zrozumienie, akceptację i wsparcie dopasowane do jego
              indywidualnych potrzeb. Zapraszam Cię do miejsca stworzonego z myślą o rodzinach, które szukają
              rzetelnej wiedzy i specjalisty, który naprawdę rozumie wyzwania neuroróżnorodności.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 grid grid-cols-3 gap-4">
            {stats.map((s, i) => (
              <div key={i} className="rounded-2xl bg-white border border-ink/5 p-5">
                <div className="font-display font-700 text-2xl text-violet-deep">{s.v}</div>
                <div className="mt-1 text-sm text-ink/50 leading-snug">{s.l}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
